import { RechargeService } from './../../../services/recharge.service';
import { AuthService } from './../../../providers/auth.service';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/*
  充值
*/
@Component({
    selector: 'page-huibowy',
    templateUrl: 'huibowy.html',
    providers: [RechargeService]
})
export class RechargeHuiBoWY {

    constructor(
        private navPar: NavParams,
        private viewCtrl: ViewController,
        private auth: AuthService,
        private iab: InAppBrowser,
        private rechargeService: RechargeService
    ) { }

    info = this.navPar.data;
    banks = [];
    currBankCode = this.info.BankCode;
    redirectUrl = '';

    ngOnInit() {
        this.info.BankCode = 'ICBC';
        this.getUrl();
    }

    //获取跳转路径
    //TQQ 2017-08-28
    getUrl() {
        let par = {
            recordId: this.info.RecodeID,
            bankco: this.info.BankCode,
            Authorization: this.auth.getToken()
        };
        this.rechargeService.rechargePost(par).then(s => {
            if (s.Result) {
                this.redirectUrl = s.Error;
            }
        });
    }

    //进入第三方支付
    //TQQ 2017-01-04
    payClick() {
        this.iab.create(this.redirectUrl, '_system');
    }

    //页面返回
    //chen 2017-01-19
    close() {
        this.viewCtrl.dismiss();
    }

    openNewSpecifiedWindow(windowName) {
        window.open('about:blank', windowName, 'width=700,height=400,menubar=no,scrollbars=no');
    }

}



// WEBPACK FOOTER //
// ./src/pages/recharge/huibowy/huibowy.ts